import { toast } from "react-toastify";
import "./confirmationCard.scss";
import React, { useState } from "react";
import AllServices from "../../Services/AllServices";
import CustomLoader from "../CustomLoader/CustomLoader";

const ConfirmationCard = ({ onClose, item, onDeleteSuccess }) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      const response = await AllServices.deleteCustomer(item);

      if (response) {
        onClose();
        onDeleteSuccess();
        toast.success("Customer deleted succussfully!");
      }
    } catch (error) {
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card-containor">
      {loading && (
        <div className="loader-overlay">
          <CustomLoader />
        </div>
      )}
      <div className="top">
        <span>
          Are you sure you want to{" "}
          <span className="highlight-delete">Delete</span> this?
        </span>
      </div>
      <div className="bottom">
        <button
          type="button"
          onClick={handleDelete}
          className="card-button-delete"
        >
          Delete
        </button>
        <button type="button" onClick={onClose} className="card-button">
          Cancel
        </button>
      </div>
    </div>
  );
};

export default ConfirmationCard;
